import request from "@/utils/request";

// 登录
export const login = (params) => {
  return request({
    url: "/api/blade-auth/oauth/token",
    method: "post",
    params,
  });
};
